import { useSelector, useDispatch } from "react-redux";
import { IStore, State } from "../DataTypes/storeTypes";
import { updateState } from "../Actions/actions";
import { LoginConnected } from "./Pages/Login";
import { RecoverConnected } from "./Pages/Recover";
import { RegisterConnected } from "./Pages/Register";
import { SetExistingClientCredentialsConnected } from "./Pages/SetExistingClientCredentials";
import { SimpleDialog } from "@powerdiary/components-library/lib";

export const ModalWrapper = () => {
    const state = useSelector((state: IStore) => state.common.state);
    const dispatch = useDispatch();

    const onModalClosed = () => {
        dispatch(updateState(State.None));
    };

    let title = null;
    let body = null;

    switch (state) {
        case State.Login:
            title = "Log in";
            body = <LoginConnected />;
            break;
        case State.Register:
            title = "Register account";
            body = <RegisterConnected />;
            break;
        case State.Recover:
            title = "Create or reset my log in details";
            body = <RecoverConnected />;
            break;
        case State.SetExistingClientCredentials:
            title = "Create or reset my log in details";
            body = <SetExistingClientCredentialsConnected />;
            break;
    }

    return (
        <>
            {state > State.None && (
                <SimpleDialog open dialogTitleText={title} renderContent={() => body} handleClose={onModalClosed} />
            )}
        </>
    );
};
